<template>
	
<core-card-foot-stat :value="value" :text="field.label" :raw="true" :invalid="value === 0" />

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			return (this.item.game.version) ? this.item.game.version.year : this.item.game.published

		}

	}

}

</script>

<style scoped>

</style>
